import { handleActions } from 'redux-actions';
import { types } from './favourites.meta';

export const initialState = {
  isItemFavourited: true,
  isItemUnFavourited: true,
  isFetchingAllFavouritedItem: true,
  isFetchingByIdFavouritedItem: true,
  isItemFavouritedRecord: true,
  isItemFavouritedError: false,
  isItemUnFavouritedError: false,
  isFetchingAllFavouritedItemError: false,
  isFetchingByIdFavouritedItemError: false,
  isItemFavouritedRecordError: false,
  favouritedItems: [],
  itemFavouritedResponse: '',
};

export const setItemFavourited = (state, action) => {
  return {
    ...state,
    isItemFavourited: true,
    isItemUnFavourited: true,
    itemFavouritedResponse: '',
  };
};
export const setItemFavouritedSuccess = (state, action) => {
  const { favouritedItems } = state;
  const { payload } = action;
  const newObj = favouritedItems?.map(item =>
    item.lineOfBusinessItemId === payload.lineOfBusinessItemId
      ? { ...item, favouritedItemId: payload?.favouritedItemId }
      : item
  );
  return {
    ...state,
    favouritedItems: [...newObj],
    isItemFavourited: false,
    itemFavouritedResponse: action.payload,
  };
};
export const setItemFavouritedError = (state, action) => {
  return {
    ...state,
    isItemFavourited: false,
    isItemFavouritedError: true,
    isFetchingAllFavouritedItemError: false,
    isItemUnFavouritedError: false,
    itemFavouritedResponse: action?.payload,
  };
};
export const setItemUnFavourited = (state, action) => {
  return {
    ...state,
    isItemUnFavourited: true,
    isItemFavourited: true,
    itemFavouritedResponse: '',
  };
};
export const setItemUnFavouritedSuccess = (state, action) => {
  return {
    ...state,
    isItemUnFavourited: false,
    itemFavouritedResponse: true,
  };
};
export const setItemUnFavouritedError = (state, action) => {
  return {
    ...state,
    isItemUnFavourited: false,
    isItemUnFavouritedError: true,
    isFetchingAllFavouritedItemError: false,
    isItemFavouritedError: false,
    itemFavouritedResponse: action?.payload,
  };
};
export const getAllFavourited = (state, action) => {
  return {
    ...state,
    isItemFavourited: true,
    isItemUnFavourited: true,
    isFetchingAllFavouritedItem: true,
    itemFavouritedResponse: '',
  };
};
export const getAllFavouritedSuccess = (state, action) => {
  const { payload } = action;
  return {
    ...state,
    isFetchingAllFavouritedItem: false,
    favouritedItems: payload?.favouritedItems,
  };
};
export const getAllFavouritedError = (state, action) => {
  return {
    ...state,
    isFetchingAllFavouritedItem: false,
    isFetchingAllFavouritedItemError: true,
    isItemFavouritedError: false,
    isItemUnFavouritedError: false,
    itemFavouritedResponse: action.payload,
  };
};

export const getByFavourited = (state, action) => {
  return {
    ...state,
    isFetchingByIdFavouritedItem: true,
    itemFavouritedResponse: '',
  };
};
export const getByFavouritedSuccess = (state, action) => {
  return {
    ...state,
    isFetchingByIdFavouritedItem: false,
    itemFavouritedResponse: action.payload,
  };
};
export const getByFavouritedError = (state, action) => {
  return {
    ...state,
    isFetchingByIdFavouritedItem: false,
    isFetchingByIdFavouritedItemError: true,
    itemFavouritedResponse: action.payload,
  };
};

export const getRecordItemFavourited = (state, action) => {
  return {
    ...state,
    isItemFavouritedRecord: true,
    itemFavouritedResponse: '',
  };
};
export const getRecordItemFavouritedSuccess = (state, action) => {
  return {
    ...state,
    isItemFavouritedRecord: false,
    itemFavouritedResponse: action.payload,
  };
};
export const getRecordItemFavouritedError = (state, action) => {
  return {
    ...state,
    isItemFavouritedRecord: false,
    isItemFavouritedRecordError: true,
    itemFavouritedResponse: action.payload,
  };
};

export const removeFavouriteItem = (state, action) => {
  const { favouritedItems } = state;
  return {
    ...state,
    itemFavouritedResponse: '',
    favouritedItems: favouritedItems?.filter(
      item => item?.lineOfBusinessItemId !== action?.payload
    ),
  };
};

export const addFavouriteItem = (state, action) => {
  return {
    ...state,
    itemFavouritedResponse: '',
    favouritedItems: [...state?.favouritedItems, action.payload],
  };
};
export default handleActions(
  {
    [types.FAVOURITED_ITEM]: setItemFavourited,
    [types.FAVOURITED_ITEM_SUCCESS]: setItemFavouritedSuccess,
    [types.FAVOURITED_ITEM_ERROR]: setItemFavouritedError,
    [types.UNFAVOURITED_ITEM]: setItemUnFavourited,
    [types.UNFAVOURITED_ITEM_SUCCESS]: setItemUnFavouritedSuccess,
    [types.UNFAVOURITED_ITEM_ERROR]: setItemUnFavouritedError,
    [types.GET_FAVOURITED_ITEM]: getAllFavourited,
    [types.GET_FAVOURITED_ITEM_SUCCESS]: getAllFavouritedSuccess,
    [types.GET_FAVOURITED_ITEM_ERROR]: getAllFavouritedError,
    [types.GET_BY_FAVOURITED_ITEM]: getByFavourited,
    [types.GET_BY_FAVOURITED_ITEM_SUCCESS]: getByFavouritedSuccess,
    [types.GET_BY_FAVOURITED_ITEM_ERROR]: getByFavouritedError,
    [types.RECORD_FAVOURITED_ITEM]: getRecordItemFavourited,
    [types.RECORD_FAVOURITED_ITEM_SUCCESS]: getRecordItemFavouritedSuccess,
    [types.RECORD_FAVOURITED_ITEM_ERROR]: getRecordItemFavouritedError,
    [types.REMOVE_FAVOURITE_ITEM]: removeFavouriteItem,
    [types.ADD_FAVOURITE_ITEM]: addFavouriteItem,
  },
  initialState
);
